module.exports = __webpack_public_path__ + "static/ChopperBikeRed-c2d0193bacf2f0969b0c8a2888c13094.webm";